<template>
  <!-- <div class="c-logo" v-show="showLogo">
    <img src="@/assets/img/arag_logo.png" width="100" alt="ARAG Logo" />
  </div>
  <p>
    <b
      >Bitte lesen und bestätigen Sie, dass Sie mit den Datenschutzbestimmungen
      einverstanden sind.</b
    >
  </p> -->
  <ion-list lines="none">
    <ion-item>
      <ion-checkbox slot="start" v-model="privacy1"> </ion-checkbox>
      <ion-label class="ion-text-wrap" color="primary">
        Ich möchte mein gesundheitliches Anliegen und meine persönlichen Daten
        dem ARAG Gesundheitsassistenten zum Zweck der Unterstützung hierzu und
        einer etwaig damit verbundenen Suche nach passenden
        Gesundheitsdienstleistern bereitstellen und akzeptiere die
        <u
          ><a href="https://www.arag.de/datenschutzerklaerung/" target="_blank"
            >Datenschutzbestimmungen</a
          ></u
        >.
        <a
          href="#"
          @click.prevent="openInfoModal(privacy1Text)"
          style="text-decoration: none;"
          >MEHR</a
        >
      </ion-label>
    </ion-item>
    <ion-item>
      <ion-checkbox slot="start" v-model="privacy2"></ion-checkbox>
      <ion-label class="ion-text-wrap" color="primary">
        Ich suche Unterstützung für mein gesundheitliches Anliegen und/oder
        Hilfe bei der Suche nach passenden Gesundheitsdienstleistern und stimme
        zu diesem Zweck der Entbindung von der ärztlichen Schweigepflicht der
        ARAG Krankenversicherungs-AG zu und akzeptiere die
        <u
          ><a href="https://www.arag.de/datenschutzerklaerung/" target="_blank"
            >Datenschutzbestimmungen</a
          ></u
        >.
      </ion-label>
    </ion-item>
    <!-- <ion-item>
      <ion-checkbox slot="start" v-model="privacy2"> </ion-checkbox>
      <ion-label class="ion-text-wrap" color="primary">
        Ich suche Unterstützung für meine gesundheitlichen Beschwerden und
        stimme den
        <u
          ><a href="#" @click.prevent="openInfoModal(privacy2Text)"
            >Datenschutzbestimmungen</a
          ></u
        >
        hierzu zu.
      </ion-label>
    </ion-item> -->
  </ion-list>
  <!-- <ion-row v-if="showNextButton">
    <ion-col>
      <next-question-button
        :disabled="!privacy1 || !privacy2"
        @click="$emit('done')"
      />
    </ion-col>
  </ion-row> -->
</template>

<script>
import {
  IonList,
  IonItem,
  IonCheckbox,
  IonLabel,
  modalController,
  // IonRow,
  // IonCol,
} from "@ionic/vue";
// import NextQuestionButton from "@lib/components/Questions/NextQuestionButton";
import InfoModal from "@lib/components/InfoModal";

export default {
  emits: ["done", "checked", "unchecked"],
  components: {
    IonList,
    IonItem,
    IonCheckbox,
    IonLabel,
    // NextQuestionButton,
    // IonRow,
    // IonCol,
  },
  props: {
    showLogo: {
      required: false,
      type: Boolean,
      default: true,
    },
    showNextButton: {
      required: false,
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      privacy1: false,
      privacy2: false,
      privacy1Label:
        "Ich möchte mein gesundheitliches Anliegen und meine persönlichen Daten dem ARAG Gesundheitsassistenten zum Zweck der Unterstützung hierzu und einer etwaig damit verbundenen Suche nach passenden Gesundheitsdienstleistern bereitstellen und akzeptiere die Datenschutzbestimmungen.",
      privacy2Label:
        // "Ich suche Unterstützung für meine gesundheitlichen Beschwerden und stimme den Datenschutzbestimmungen hierzu zu.",
        "Ich suche Unterstützung für mein gesundheitliches Anliegen und/oder Hilfe bei der Suche nach passenden Gesundheitsdienstleistern und stimme zu diesem Zweck der Entbindung von der ärztlichen Schweigepflicht der ARAG Krankenversicherungs-AG zu und akzeptiere die Datenschutzbestimmungen.",
      privacy1Text:
        // "<p>Die von mir angegebenen persönlichen Daten, das sind Anrede, Vorname, Nachname, PLZ, E-Mail Adresse und Telefonnummer, werden an die ARAG weitergegeben. Die bei der ARAG in diesem Zusammenhang gespeicherten Daten werden ausschließlich zu Zwecken des telefonischen Rückrufs oder zur Kontaktaufnahme per E-Mail verarbeitet. Sie können  jederzeit die Kontaktaufnahme untersagen oder die Löschung Ihrer Daten verlangen. Rechtsgrundlage für die Datenverarbeitung ist Art. 6 Abs. 1 Satz 1 lit. b DSGVO.</p>",
        "<p>Die Angaben zu Ihren gesundheitlichen Anliegen, Vorname, Nachname, Alter und Geschlecht, Telefonnummer, Information zur ARAG-Krankenversicherung und die Vertragsdaten (E-Mail-Adresse, Passwort, Vorname, Nachname und Adresse) werden von Roodie an die ARAG Krankenversicherungs-AG GmbH zum Zweck der Unterstützung für mein gesundheitliches Anliegen und/oder Suche nach Gesundheitsdienstleistern weitergegeben und von dieser ausschließlich zu diesem Zweck verarbeitet und genutzt. Ferner werden bei Vereinbarung eines Arzt-/Kliniktermins die Daten des behandelnden Gesundheitsdienstleistern (Vorname, Nachname, Fachrichtung), Zeitpunkt und Ort des Termins von der ARAG Krankenversicherungs-AG an Roodie übermittelt, um diese Informationen in meinem Konto in der Roodie ARAG App zu speichern. Diese Einwilligung kann von mir jederzeit widerrufen werden.</p><p>Es handelt sich dabei um personenbezogene Daten, die sich auf Ihre körperliche oder mentale Gesundheit, einschließlich der Erbringung von Gesundheitsdienstleistungen beziehen und aus denen Informationen über Ihren Gesundheitszustand hervorgehen. Rechtsgrundlage für die Verarbeitung dieser Daten ist Ihre Einwilligung gemäß Art 9 Abs 2 lit a DSGVO.</p>",
      privacy2Text:
        "<p>Die Angaben zu meinen Symtomen, Vorname, Nachname, Alter und Geschlecht, Telefonnummer und die Angaben zur Ihren Vertragsdaten (E-Mail-Adresse, Versicherungsnummer, Geburtsdatum) werden an die ARAG weitergegeben und von diesen gespeichert, um Sie betreuen zu können. Um Ihre Suchanfrage beantworten zu können, benötigt ARAG von Ihnen Angaben zu Ihrer physischen und möglicherweise auch psychischen Verfassung. Hierbei handelt es sich um Gesundheitsdaten im Sinne der Datenschutz-Grundverordnung, Art. 4 Nr. 15 DSGVO. Ferner werden die Angaben, die der Nutzer im Zusammenhang mit einer auf seinen Wunsch erfolgenden Vereinbarung eines Termins bei einem Arzt durch die Vermittlung über das ARAG Case Management macht, sowie Angaben, die er im Rahmen der Nachbetreuung macht, verarbeitet.  Es handelt sich dabei um personenbezogene Daten, die sich auf die körperliche oder geistige Gesundheit einer natürlichen Person, einschließlich der Erbringung von Gesundheitsdienstleistungen beziehen und aus denen Informationen über deren Gesundheitszustand hervorgehen. Rechtsgrundlage für die Verarbeitung dieser Daten ist Ihre Einwilligung gemäß Art. 9 Abs. 2 lit. a DSGVO.</p>",
    };
  },
  watch: {
    privacy1() {
      this.checkPrivacy();
    },
    privacy2() {
      this.checkPrivacy();
    },
  },
  methods: {
    checkPrivacy() {
      if (this.privacy1 && this.privacy2) {
        this.$emit("checked", {
          privacy1Label: this.privacy1Label,
          privacy2Label: this.privacy2Label,
        });
      } else {
        this.$emit("unchecked");
      }
    },
    async openInfoModal(text) {
      const modal = await modalController.create({
        component: InfoModal,
        cssClass: "my-custom-class",
        componentProps: {
          title: "Datenschutzbestimmungen",
          text: text,
        },
      });
      return modal.present();
    },
  },
};
</script>

<style lang="scss" scoped>
.c-logo {
  max-width: 200px;
  display: inline-block;
  margin-right: 20px;
}
</style>
